const API_ENDPOINT = 'https://api.lomadee.com/v3/1506315914361648a8422/';
const API_ENDPOINT_OLD = 'https://api.lomadee.com/v2/1506315914361648a8422/';
const API_SOURCEID = "35818716";
const functions = require('../utils/functions')
import axios from 'axios'

function getCoupons(){
  return axios.get(API_ENDPOINT_OLD + 'coupon/_all?sourceId=' + API_SOURCEID);
}

function getStores(){
  return axios.get(API_ENDPOINT + 'coupon/_stores?sourceId=' + API_SOURCEID);
}

function getStore(id){
  return axios.get(API_ENDPOINT + '_all?sourceId=' + API_SOURCEID + '&storeId=' + id);
}

function getStoreCoupons(storeId){
  return axios.get(API_ENDPOINT_OLD + 'coupon/_all?sourceId=' + API_SOURCEID + '&storeId=' + storeId);
}

function getProducts(categoryId = null){
  if(categoryId){
    return axios.get(API_ENDPOINT + 'offer/_category/' + categoryId + '/?sourceId=' + API_SOURCEID);
  }else{
    return axios.get(API_ENDPOINT + 'offer/_bestsellers/?sourceId=' + API_SOURCEID);
  }
}

function getProductCategories(){
  return axios.get(API_ENDPOINT + 'category/_all/?sourceId=' + API_SOURCEID);
}

function convertCoupon(coupon, StoreId = null, CategoryId = null){
  var slug = functions.stringToSlug(coupon.store.name + '-' + coupon.store.id);
  return {
    'CouponId': coupon.id,
    'StoreId': StoreId,
    'CategoryId': CategoryId,
    'store': coupon.store.name,
    'category': coupon.category.name,
    'slug': slug,
    'originalId': coupon.id,
    'couponType': 'lomadee',
    'description': coupon.description,
    'trackingLink': coupon.link,
    'image': coupon.store.image,
    'value': coupon.discount,
    'code': coupon.code,
    'dateBegin': coupon.vigency,
    'dateEnd': coupon.vigency
  }
}

export default {
  getCoupons,
  getStores,
  getStore,
  getStoreCoupons,
  convertCoupon,
  getProducts,
  getProductCategories
}


// WEBPACK FOOTER //
// ./src/drivers/lomadee.js